import omit from 'lodash/omit';
import pick from 'lodash/pick';

import { RESTRICTED_WORK_NAMES, RESTRICTED_COMPOSER_NAMES } from 'constants/consts';

import { condenseImageObject, expandImageObject } from 'utils/globals/imageOptimizatons';

export const transformAggregatedOptions = response => response?.data || [];

export const selectAggregatedOptions = response => response?.data || [];

export const transformRestrictedWorksFromRoleOverlap = response => {
  const data = response?.data;
  const filteredData = data?.filter(
    ({ work }) =>
      !RESTRICTED_WORK_NAMES.includes(work?.name) &&
      !work?.creators?.some(creator => RESTRICTED_COMPOSER_NAMES.includes(creator?.name)),
  );

  return {
    ...response,
    data: filteredData,
  };
};

export const transformContributionForMediaSlug = contribution => ({
  ...pick(contribution, ['id', 'contributionType', 'credit', 'professions']),
  organization: contribution?.organization?.id
    ? {
        id: contribution?.organization?.id,
        name: contribution?.organization?.name,
        slug: contribution?.organization?.slug,
      }
    : null,
  profile: contribution?.profile?.id
    ? {
        id: contribution?.profile?.id,
        name: contribution?.profile?.name,
        slug: contribution?.profile?.slug,
      }
    : null,
});

export const transformProductionsForMediaSlug = response => {
  const { data } = response || {};

  return {
    ...response,
    data: data?.map(option => ({
      ...omit(option, [
        'addedBy',
        'approvedBy',
        'createdAt',
        'forEntity',
        'forEntityId',
        'lastQcAt',
        'lastValidatedAt',
        'lastValidatedByUser',
        'missing',
        'numbers',
        'pendingRelatedEntities',
        'performances',
        'periode',
        'poster',
        'producerApproved',
        'productionDates',
        'productionToTags',
        'programAnnouncementDate',
        'publishedByUser',
        'published_at',
        'rentals',
        'revivedProduction',
        'scrapeRequest',
        'stats',
        'trailer',
        'updatedAt',
        'validationReasons',
        'validationStatus',
        'validation_requested_at',
        'years',
      ]),
      poster: condenseImageObject({
        blurHash: option?.poster?.blurHash,
        original: option?.poster?.file?.urls?.original,
      }),
      trailer: {
        blurHash: option?.trailer?.blurHash,
        url: option?.trailer?.url,
        thumbnail: condenseImageObject({
          blurHash: option?.trailer?.thumbnail?.urls?.blurHash,
          original: option?.trailer?.thumbnail?.urls?.original,
        }),
      },
      contributions: option?.contributions?.map(transformContributionForMediaSlug),
    })),
  };
};

export const selectProductionsForMediaSlug = response => {
  const { pages } = response || {};
  const isInfiniteQuery = pages?.length > 0;

  const processData = data =>
    data?.map(option => {
      const expandedPoster = expandImageObject(option?.poster);
      const expandedTrailerThumbnail = expandImageObject(option?.trailer?.thumbnail);

      return {
        ...option,
        poster: {
          blurHash: expandedPoster?.blurHash,
          file: expandedPoster?.original
            ? {
                urls: expandedPoster,
              }
            : null,
        },
        trailer: {
          ...option?.trailer,
          thumbnail: expandedTrailerThumbnail?.original
            ? {
                urls: expandedTrailerThumbnail,
              }
            : null,
        },
      };
    });

  if (isInfiniteQuery) {
    return {
      ...response,
      pages: pages?.map(page => ({
        ...page,
        data: processData(page?.data),
      })),
    };
  }

  return {
    ...response,
    data: processData(response?.data),
  };
};
